import { FormattedMessage } from 'react-intl';

import Icon from '../Icon/Icon';

import { Props } from './UserAverageRating.model';
import { Score } from '../../Helpers/useScoreHelper';

import styles from './UserAverageRating.module.scss';

const UserRating = ({ isCurrentUser, score }: Props) => {

	return (
		<div className={styles.wrapper}>
			<div className={`${styles.iconWrapper} ${styles[score]}`}>
				{score === Score.Substandard && <Icon height="24px" name="bad-star" type="custom" width="24px" />}
				{score === Score.Reasonable && <Icon height="24px" name="reasonable-star" type="custom" width="24px" />}
				{score === Score.Good && <Icon height="20px" name="star" type="solid" width="20px" />}
				{score === Score.Exceptional && <Icon height="20px"name="stars" type="solid" width="20px" />}
			</div>
			<div className={styles.scoreDescription}>
				<h3><FormattedMessage id={`ratings.score.${score}`} /></h3>
				<FormattedMessage id={isCurrentUser ? `ratings.scoreDescriptionForCurrentUser.${score}` :`ratings.scoreDescription.${score}`} />
			</div>
		</div>
	);
}

export default UserRating;